"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addEventListener;
function addEventListener(node, eventName, handler, options) {
    node.addEventListener(eventName, handler, options);
    return {
        removeEventListener: function removeEventListener() {
            node.removeEventListener(eventName, handler, options);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-cursor-position/dist/utils/addEventListener.js
// module id = 268
// module chunks = 35783957827783